import { getUrlConfig } from './url.config';
import { IEnvironment } from './types';
import packageJson from '../../package.json';

const BASE_URL = 'https://europe-west1-ihub-projects-developmen-af75f.cloudfunctions.net';

export const developmentEnvironment: IEnvironment = {
  ...getUrlConfig(BASE_URL),
  GOOGLE_AUTH_SERVICE_ID: '68673811523-gev66rqd3sa5sknb5ouj07hfmtga8h0d.apps.googleusercontent.com',
  API_KEY: 'AIzaSyDG4PeXd9I_o0MpE3id7YQXECr6ThI-54I',
  VIDEOCHAT_LINK: 'development-videochat.mindlyspace.com',
  AMPLITUDE_API_KEY: '27e96ef6fe0866477bca1ccc29bf28ea',
  REMOTE_CONFIG: {
    FETCH_INTERVAL_IN_SECONDS: 10,
    DEFAULT_VALUES: {
      apple_pay_enabled: false,
      google_pay_enabled: false,
      is_supported_app_versions_feature_enabled: true,
      is_stream_chat_enabled: true,
      client_apps_flyer_one_link_enabled_specialists: '',
      client_apps_flyer_one_link_enabled_onboarding: '',
      is_nps_interview_enabled: true,
      is_nps_interview_new: true,
      SUPPORTED_APP_VERSIONS: JSON.stringify({
        [packageJson['api-version']]: {},
      }),
    },
  },
  INTERCOM: {
    APP_ID: 'isk9oqqt',
  },
  AGORA: {
    appID: '6c95d79691c1439a9bc3f5a38e444009',
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyATFJx5XWuMdAbB5ipkLU0HyOPdoRc8EXw',
    authDomain: 'auth-test-c7550.mindlyspace.com',
    projectId: 'ihub-projects-developmen-af75f',
    storageBucket: 'ihub-projects-developmen-af75f.appspot.com',
    messagingSenderId: '68673811523',
    appId: '1:68673811523:web:b7aaaa3861a303c65190f6',
    measurementId: 'G-TQ71QZLWTY',
    databaseURL: 'http://localhost:4001/',
  },
  STRIPE_PUBLIC_KEY:
    import.meta.env?.VITE_STRIPE_PUBLIC_KEY ??
    'pk_test_51PQUoGHbh9nMtikNZIGQkz4rVYybFKZOWowgNh5daKHRrK08a9YOjOi22aT4Sb5s8Hm0oPiwSVpFQphwrfKOlYR500W8lmuLNU',
  APPLE_PAY_MERCHANT_ID: 'merchant.com.mindly',
  DEEP_LINK: 'https://mindlyspacedevelop.page.link/',
  APPS_FLYER_ONE_LINK: 'https://mindlyspace.onelink.me/SyFA',
  FB_PIXEL_ID: '858304681898657',
  TIK_TOK_PIXEL_ID: 'D07NN93C77U8J8QMNBN0',
  MAIN_WEB_URL: import.meta.env?.VITE_MAIN_WEB_URL ?? 'https://app-user-pwa.web.app',
  WEBSITE_URL: 'https://website-3.web.app',
  STREAM_API_TOKEN: 'zar9mnb8v4qs',

  JITSI_APP_ID: 'vpaas-magic-cookie-b157367e1efa48ceae44d6842caa9336',
};
